import { render, staticRenderFns } from "./StorePricesPanel.vue?vue&type=template&id=311aa062&scoped=true"
import script from "./StorePricesPanel.vue?vue&type=script&lang=js"
export * from "./StorePricesPanel.vue?vue&type=script&lang=js"
import style0 from "./StorePricesPanel.vue?vue&type=style&index=0&id=311aa062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311aa062",
  null
  
)

export default component.exports